<!--  -->
<template>
  <div class="composite-page">
    <!-- <div class="page-top"></div> -->
    <screen-panel :isExpand="isOpen" class="panel">
      <screen-box title="月度碳排放趋势(tCO2e)" height="33.3%" class="screen-top">
        <CarbonOverviewEmssionTrendByMonths></CarbonOverviewEmssionTrendByMonths>
        <!-- <PeopleTypePie
          :personTypeData="personTypeData"
          style="margin-top: 10px"
        ></PeopleTypePie> -->
      </screen-box>
      <screen-box title="各建筑碳排放统计(tCO2e)" height="33.3%">
        <CarbonOverviewEmssionByBuild></CarbonOverviewEmssionByBuild>
        <!-- <CarbonEmssionTrendByYear
          style="margin-top: 10px"
        ></CarbonEmssionTrendByYear> -->
      </screen-box>

      <screen-box title="碳排放现状" height="33.3%">
        <div class="top bg">
          <div class="top-content flex-row">
            <div class="top-left">
              <div class="value">{{ info.carbonTarget || 0 }}</div>
              <div class="info">碳配额(吨)</div>
            </div>
            <div class="top-middle">
              <div class="value">
                {{ info.carbonLeftEmission || 0 }}
              </div>
              <div class="info">碳配额余额(吨)</div>
            </div>
            <div class="top-right">
              <div class="value">
                {{ info.carbonEmission || 0 }}
              </div>
              <div class="info">实际碳排放量(吨)</div>
            </div>
          </div>
        </div>
        <div class="bottom flex-row">
          <div class="bottom-title">碳配额余额</div>
          <div class="bottom-bar">
            <el-progress :percentage="perData" :stroke-width="strokeWidth" :text-inside="true"></el-progress>
          </div>
        </div>
      </screen-box>
    </screen-panel>
    <div class="middle">
      <screen-box title="数据总览" height="33.3%" style="
          height: 33.3%;
          position: absolute;
          left: 100%;
          width: 560px;
          z-index: 2;
          position: relative;
        ">
        <div style="display: flex;">
          <el-date-picker @change="handleDateChange" value-format="yyyy-MM-dd" v-model="queryDate" type="date" placeholder="选择日期" style="width: 40%" :clearable="choseFlag">
          </el-date-picker>
        </div>
        <!-- <div style="box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.5);"> -->
        <div>
          <div class="box-top flex-row">
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/electricity.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">用电量</div>
                <div>
                  <span class="item-content_value yellow-font">{{
                    energy.energyQuantity
                  }}</span>
                  <span class="unit-span">kW·h</span>
                </div>
              </div>
            </div>
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/co2.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">碳排放量</div>
                <div>
                  <span class="item-content_value green-font">{{
                    energy.carbonEmission
                  }}</span>
                  <span class="unit-span">tCO2e</span>
                </div>
              </div>
            </div>
            <!-- <div class="item-icon">
            <img src="../../../../src/common/assets/images/减排.png" alt="" />
          </div>
          <div class="item-content flex-row">
            <div class="item-content_title">碳排放统计</div>
            <div class="item-content_value">251</div>
            kg kg
          </div> -->
          </div>
        </div>
        <div style="display: flex; margin-top: 50px;">
          <el-date-picker @change="handleSecondDateChange" value-format="yyyy-MM" v-model="querySecondDate" type="month" placeholder="选择日期" style="width: 40%" :clearable="choseFlag">
          </el-date-picker>
        </div>
        <div>
          <div class="box-top flex-row">
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/gas.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">用气量</div>
                <div>
                  <span class="item-content_value yellow-font">{{
                    energyData.gas
                  }}</span>
                  <span class="unit-span">m³</span>
                </div>
              </div>
            </div>
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/co2.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">碳排放量</div>
                <div>
                  <span class="item-content_value green-font">{{
                    energyData.gasEmission
                  }}</span>
                  <span class="unit-span">tCO2e</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-top flex-row">
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/oil.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">用油量</div>
                <div>
                  <span class="item-content_value yellow-font">{{
                    energyData.petroleum
                  }}</span>
                  <span class="unit-span">t</span>
                </div>
              </div>
            </div>
            <div class="item flex-row">
              <!-- <div class="item-icon">
                <img src="../../../../src/common/assets/images/co2.png" alt="" />
              </div> -->
              <div class="item-content flex-valign">
                <div class="item-content_title">碳排放量</div>
                <div>
                  <span class="item-content_value green-font">{{
                    energyData.petroleumEmission
                  }}</span>
                  <span class="unit-span">tCO2e</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <CarbonEmssionTrendByYear></CarbonEmssionTrendByYear> -->
      </screen-box>
    </div>
    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <div class="bacnet flex-row">
        <div class="bacnet-item" v-for="item in bacnetList" :key="item.value">
          <div class="item_label">{{ item.label }}</div>
          <div class="item_value">{{ item.value }} {{ item.unit }}</div>
          <!-- <div class="item_unit">{{ item.unit }}</div> -->
        </div>
      </div>
      <screen-box title="年度碳排放趋势(tCO2e)" height="33.3%">
        <CarbonEmssionTrendByYear></CarbonEmssionTrendByYear>
      </screen-box>
      <screen-box title="累计碳排放(tCO2e)" height="33.3%">
        <CarbonEmssionStatics></CarbonEmssionStatics>
      </screen-box>
      <screen-box title="Top5用电碳排放量">
        <!-- <CarbonOverviewEmssionTrendByMonths
          style="margin-top: 10px"
        ></CarbonOverviewEmssionTrendByMonths> -->
        <CarbonEmssionByTop></CarbonEmssionByTop>

        <!-- <CarbonEmssionByTop></CarbonEmssionByTop> -->
      </screen-box>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "@ISS/situation/components/ScreenPanel.vue";
import ScreenBox from "@ISS/situation/components/ScreenBox.vue";
import CarbonEmssionByTop from "@ISS/situation/components/CarbonEmssionByTop";

// import PeopleTypePie from "@ISS/situation/components/PersonTypePie";
// import CarbonEmssionByTop from "@ISS/situation/components/CarbonEmssionByTop";
import CarbonEmssionTrendByYear from "@ISS/situation/components/CarbonEmssionTrendByYear";
import CarbonOverviewEmssionByBuild from "@ISS/situation/components/CarbonOverviewEmssionByBuild";
import CarbonOverviewEmssionTrendByMonths from "@ISS/situation/components/CarbonOverviewEmssionTrendByMonths";
import CarbonEmssionStatics from "@ISS/situation/components/CarbonEmssionStatics";
import API from "@ISS/situation/api/index";
import { Dates, Dic } from "$utils";

export default {
  data() {
    return {
      strokeWidth: 12,
      choseFlag: false,
      personTypeData: {},
      isOpen: false,
      queryDate: "",
      statYear: "",
      energy: { energyQuantity: "", carbonEmission: "" },
      perData: 0,
      info: {
        carbonEmission: 0, //实际碳排放量
        carbonTarget: 0,
        carbonLeftEmission: 0, //余额
      },
      bacnetList: [],
      querySecondDate: "",
      energyData: {
        gas: 0,
        gasEmission: 0,
        petroleum: 0,
        petroleumEmission: 0,
      },
    };
  },

  components: {
    screenPanel,
    ScreenBox,
    CarbonEmssionByTop,
    CarbonOverviewEmssionByBuild,
    // PeopleTypePie,
    // CarbonEmssionByTop,
    CarbonOverviewEmssionTrendByMonths,
    CarbonEmssionTrendByYear,
    CarbonEmssionStatics,
  },

  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
    this.queryData();
    this.querySecondData();
    this.queryDataByYear();
    this.queryBacnet();
    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
  },
  created() {
    this.queryDate = Dates.format(new Date(), "yyyy-MM-dd");
    this.querySecondDate = Dates.format(new Date(), "yyyy-MM");
    this.statYear = new Date().getFullYear();
  },
  methods: {
    handleSecondDateChange(data) {
      this.querySecondDate = data;
      this.querySecondData();
    },
    querySecondData() {
      this.$fetch(
        "/bms/carbon/monthly/carbon/gas/petroleum.json" +
          "?date=" +
          this.querySecondDate
      ).then((res) => {
        if (res.success) {
          this.energyData.gas = res.returnObj.gas
            ? Number(res.returnObj.gas).toFixed(2)
            : 0;
          this.energyData.gasEmission = res.returnObj.gasEmission
            ? Number(res.returnObj.gasEmission).toFixed(2)
            : 0;
          this.energyData.petroleum = res.returnObj.petroleum
            ? Number(res.returnObj.petroleum).toFixed(2)
            : 0;
          this.energyData.petroleumEmission = res.returnObj.petroleumEmission
            ? Number(res.returnObj.petroleumEmission).toFixed(2)
            : 0;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleDateChange(data) {
      this.queryDate = data;
      this.queryData();
    },
    queryData() {
      this.$fetch(
        API.carbonByLastDays + "?day=" + this.queryDate + "&&num=1"
      ).then((res) => {
        if (res.success) {
          this.energy.energyQuantity = res.returnObj[0].energyQuantity
            ? res.returnObj[0].energyQuantity.toFixed(2)
            : 0;
          this.energy.carbonEmission = res.returnObj[0].carbonEmission
            ? res.returnObj[0].carbonEmission.toFixed(2)
            : 0;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    queryDataByYear() {
      this.$fetch(
        "bms/carbon/year/statistics/total/list.json" + "?year=" + this.statYear
      ).then((res) => {
        if (res.success) {
          console.log(res, ">>>>res");
          //    carbonEmission: 0, //实际碳排放量
          // carbonTarget: 0,
          // carbonLeftEmission: 0, //余额
          this.info.carbonEmission =
            res.returnObj.carbonEmission.toFixed(2) || 0;
          this.info.carbonTarget = res.returnObj.carbonTarget
            ? res.returnObj.carbonTarget.toFixed(2)
            : 0;
          this.info.carbonLeftEmission = res.returnObj.carbonLeftEmission
            ? res.returnObj.carbonLeftEmission.toFixed(2)
            : 0;
          let perTemData =
            Number(this.info.carbonLeftEmission) /
            Number(this.info.carbonTarget);
          let perTem = Number((perTemData * 100).toFixed(2))
          this.perData = perTem > 0 ? perTem : 0
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //queryBacnetStatusList
    queryBacnet() {
      //Dic.findByValue("SENU039", row.vehicleColor); 风向
      this.$fetch(API.queryBacnetStatusList, {
        currentStatusType: "weather",
      }).then((res) => {
        if (res.success) {
          res.returnObj[0].deviceStatusList.forEach((res) => {
            if (res.currentStatusKey === "wind_direction") {
              this.bacnetList.push({
                label: res.currentStatusName,
                unit: res.unit,
                value: Dic.findByValue("SENU111", res.currentStatusValue ? Math.round(res.currentStatusValue) : 0),
              });
            } else {
              this.bacnetList.push({
                label: res.currentStatusName,
                unit: res.unit,
                value: res.currentStatusValue,
              });
            }
            // console.log(res, ">>>>>>res");
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.composite-page {
  position: relative;
  width: 100%;
}

.page-content {
  position: absolute;
  width: 100%;
  height: calc(100% - 59px);
}

.page-top {
  height: 59px;
  background: linear-gradient(
    45deg,
    rgba(13, 15, 22, 0.76) 0%,
    rgba(13, 15, 22, 0.456) 77%,
    rgba(13, 15, 22, 0) 100%
  );
}

.margin59 {
  margin-top: 59px;
}

.panel {
  height: 100%;

  .screen-top {
    @extend.margin59;
  }

  // top: 59px;
}

.bacnet {
  height: 59px;
  width: 100%;
  display: flex;
  justify-content: center;

  &-item {
    color: #fff;
    padding: 5px;
  }
}

.bottom {
  margin-top: 16px;
}

.margin-10 {
  margin-top: 10px;
}

.box-top {
  height: 20%;
  margin-top: 10px;

  img {
    width: 72px;
  }

  // @extend.margin-10;
  .item {
    height: 75px;
    flex: 1;
    margin: auto;
  }

  .item-content {
    padding: 0 7px;
    margin: auto 0px;

    .unit-span {
      font-size: 18px;
      margin-left: 4px;
      // color: rgba(255, 255, 255, 0.7);
      // color: #ffffff;
      color: #d2691e;
      font-weight: 600;
    }

    &_title {
      font-size: 18px;
      // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      // font-weight: 400;
      font-weight: 600;
      // color: rgba(255, 255, 255, 0.7);
      // color: #ffffff;
      color: #d2691e;
    }

    &_value {
      margin-top: 8px;
      font-size: 28px;
      font-weight: 900;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      // text-shadow: 0px 1px 11px rgba(255, 196, 32, 0.6784);
      -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .yellow-font {
      color: #d2691e;
      // text-shadow: 0px 1px 11px rgba(255, 196, 32, 0.6784);
    }

    .green-font {
      color: #d2691e;
      // text-shadow: 0px 0px 10px rgba(32, 255, 147, 0.6784);
    }
  }
}

.middle {
  position: relative;
  z-index: 2;
  width: 560px;
  @extend.margin59;
  margin-left: 5%;

  .date {
    position: absolute;
    left: 50%;
    top: 4%;

    &-label {
      color: #fff;
      line-height: 28px;
      height: 28px;
      padding-right: 14px;
    }
  }
}

.bottom-title {
  color: #fff;
  margin-right: 10px;
}

.bottom-bar {
  flex: 1;
  // width: ;
}

.top {
  height: 120px;

  &-content {
    height: 100%;
  }

  .title {
    color: #fff;
  }

  .value {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
  }

  .info {
    color: #72d4ff;
    margin-top: 10px;
  }

  &-left {
    // padding: 20px;
    margin: auto 0;
    width: 120px;
    text-align: center;

    .info {
      color: #007af2;
    }
  }

  &-middle {
    // padding: 20px;
    margin: auto 0;
    width: 140px;
    text-align: center;
    // border-right: 2px solid #305c86;
  }

  &-right {
    margin: auto 0;
    text-align: center;

    // padding: 20px;
  }
}

.bg {
  height: 120px;
  background-repeat: no-repeat;
  background-image: url("../../../common/assets/images/碳排放背景.png");
}
</style>
